import { cn } from '@/lib/utils';

interface VideoPlayerProps {
  src: string;
  className?: string;
  controls?: boolean;
}

export default function VideoPlayer({ src, className, controls = true }: VideoPlayerProps) {
  return <video src={src} controls={controls} className={cn('w-full rounded-lg bg-black', className)} preload="metadata" />;
}
